import { useRef } from "react";
import styles from "./AccordionItem.module.css";
import { DropdownArrowIcon } from "../../assetLoader";
const AccordionItem = ({ active, onToggle, ques, ans }) => {
  const contentEl = useRef();

  return (
    <li
      className={active ? styles.accordion_item_active : styles.accordion_item}
    >
      <button className={styles.button} onClick={onToggle}>
        {ques}
        <span className={styles.control}>
          <DropdownArrowIcon
            color="#34cb65"
            style={{ rotate: active ? "180deg" : "0deg" }}
          />
        </span>
      </button>
      <div
        ref={contentEl}
        className={styles.answer_wrapper}
        style={
          active
            ? { height: contentEl.current.scrollHeight + 0 }
            : { height: "0px" }
        }
      >
        <div className={styles.answer}>{ans}</div>
      </div>
    </li>
  );
};

export default AccordionItem;
